/* src/app/modules/taxes/quarterly-tax-receipt/quarterly-tax-receipt-list/quarterly-tax-receipt-list.component.css */
:host {
  --qtr-brand: #e3fd64;
  --qtr-brand-d: #4d7a00;
  --qtr-brand-bg: rgba(227, 253, 100, 0.08);
  --qtr-text: #1a1d23;
  --qtr-muted: #6b7280;
  --qtr-border: #e5e7eb;
  --qtr-surface: #ffffff;
  --qtr-radius: 10px;
  --qtr-shadow: 0 2px 8px rgba(0,0,0,0.07);
  display: block;
}
.qtr-page {
  padding: 0 24px 24px;
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.qtr-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  padding: 56px 24px;
}
.qtr-loading__dots {
  display: flex;
  gap: 8px;
}
.qtr-loading__dots span {
  display: block;
  width: 9px;
  height: 9px;
  border-radius: 50%;
  background: var(--qtr-brand);
  opacity: 0.3;
  animation: qtr-pulse 1.2s ease-in-out infinite;
}
.qtr-loading__dots span:nth-child(2) {
  animation-delay: 0.2s;
}
.qtr-loading__dots span:nth-child(3) {
  animation-delay: 0.4s;
}
@keyframes qtr-pulse {
  0%, 80%, 100% {
    opacity: 0.3;
    transform: scale(0.9);
  }
  40% {
    opacity: 1;
    transform: scale(1.15);
  }
}
.qtr-loading p {
  margin: 0;
  font-size: 13px;
  color: var(--qtr-muted);
}
.qtr-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  padding: 56px 24px;
  text-align: center;
}
.qtr-empty__art {
  width: 60px;
  height: 60px;
  border-radius: 16px;
  background: var(--qtr-brand-bg);
  display: flex;
  align-items: center;
  justify-content: center;
}
.qtr-empty__art mat-icon {
  font-size: 30px;
  width: 30px;
  height: 30px;
  color: var(--qtr-brand);
}
.qtr-empty__title {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: var(--qtr-text);
}
.qtr-empty__sub {
  margin: 0;
  font-size: 13px;
  color: var(--qtr-muted);
}
.qtr-edit-page {
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.qtr-edit-header {
  display: flex;
  align-items: center;
  gap: 12px;
}
.qtr-edit-header__title {
  margin: 0;
  font-size: 19px;
  font-weight: 700;
  color: var(--qtr-text);
}
.qtr-edit-header__sub {
  margin: 3px 0 0;
  font-size: 12.5px;
  color: var(--qtr-muted);
}
.qtr-card {
  background: var(--qtr-surface);
  border: 1px solid var(--qtr-border);
  border-radius: var(--qtr-radius);
  box-shadow: var(--qtr-shadow);
  overflow: hidden;
}
.qtr-card__head {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 16px;
  background: var(--qtr-brand);
}
.qtr-card__head mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
  color: var(--qtr-brand-d);
}
.qtr-card__head-label {
  font-size: 13px;
  font-weight: 600;
  color: var(--qtr-brand-d);
}
.qtr-card__body {
  padding: 20px;
}
.qtr-edit-layout {
  display: flex;
  gap: 24px;
  align-items: flex-start;
}
.qtr-edit-layout__form {
  flex: 0 0 320px;
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.qtr-edit-layout__doc {
  flex: 1;
  min-width: 0;
}
.qtr-field {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-bottom: 12px;
}
.qtr-field label {
  font-size: 12.5px;
  font-weight: 500;
  color: var(--qtr-muted);
}
.qtr-field input {
  width: 100%;
  padding: 8px 12px;
  border: 1px solid var(--qtr-border);
  border-radius: 8px;
  font-size: 14px;
  color: var(--qtr-text);
  background: #fff;
  box-sizing: border-box;
  transition: border-color 0.15s;
}
.qtr-field input:focus {
  outline: none;
  border-color: var(--qtr-brand);
}
.qtr-save-bar {
  display: flex;
  gap: 10px;
  padding-top: 4px;
}
.qtr-doc-wrap {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.qtr-pdf-preview {
  height: 70vh;
  border-radius: var(--qtr-radius);
  overflow: hidden;
}
.qtr-img-preview {
  max-width: 100%;
  border-radius: var(--qtr-radius);
  border: 1px solid var(--qtr-border);
}
@media (max-width: 768px) {
  .qtr-edit-layout {
    flex-direction: column;
  }
  .qtr-edit-layout__form {
    flex: none;
    width: 100%;
  }
}
/*# sourceMappingURL=quarterly-tax-receipt-list.component.css.map */
